<template>
  <div>
    <my-notification :icon="'joomla'">
      <template #title>
        {{ $t('compScenarioDocsTeam.title-1') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>Olivier Aumont : <em>IRD, Paris</em></li>
          <li>Jérôme Mariette : <em>INRAE, Toulouse</em></li>
        </ul>
      </div>
    </my-notification>
    <br />
    <my-notification :icon="'cogs'">
      <template #title>
        {{ $t('compScenarioDocsTeam.title-2') }}
      </template>
      <p></p>
      <ul class="bcteam">
        <li>
          Samuel Calvet : <em>IN2P3, Clérmont-Ferrand</em> ({{
            $t('compScenarioDocsTeam.desc-1')
          }}, {{ $t('compScenarioDocsTeam.desc-2') }})
        </li>
        <li>
          Catherine Gourdon : <em>Sorbonne Université, Paris</em> ({{
            $t('compScenarioDocsTeam.desc-1')
          }}, {{ $t('compScenarioDocsTeam.desc-2') }})
        </li>
        <li>
          Laurent Pagani : <em>CNRS, Paris</em> ({{
            $t('compScenarioDocsTeam.desc-1')
          }}, {{ $t('compScenarioDocsTeam.desc-2') }})
        </li>
        <li>
          Gérald Salin : <em>INRAE, Toulouse</em> ({{
            $t('compScenarioDocsTeam.desc-3')
          }})
        </li>
        <li>
          Bernard Schéou : <em>Université de Perpignan, Perpignan</em> ({{
            $t('compScenarioDocsTeam.desc-1')
          }}, {{ $t('compScenarioDocsTeam.desc-2') }})
        </li>
        <li>
          Sophie Servan : <em>DESY, Hambourg</em> ({{
            $t('compScenarioDocsTeam.desc-4')
          }})
        </li>
        <li>
          Aurélie Taguet : <em>Ecole des Mines d'Alès, Alès</em> ({{
            $t('compScenarioDocsTeam.desc-1')
          }}, {{ $t('compScenarioDocsTeam.desc-2') }})
        </li>
      </ul>
      <!-- </p> implied end tag -->
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Team',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
